import { Button, Flex, Spacing, Text, useModal } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'

export const DisconnectStripeAccountSection = (): ReactElement => {
  const { t } = useTranslation()
  const { open } = useModal(ModalId.DisconnectStripeAccountModal)

  const handleDisconnectClick = () => {
    open()
  }

  return (
    <Flex alignItems="flex-start" flexDirection="column" gap={Spacing.S8}>
      <Text variant="bodyLG" weight="medium">
        {t('settings.organization.card_payments.configuration.disconnect.title')}
      </Text>
      <Text colorVariant="secondary">
        {t('settings.organization.card_payments.configuration.disconnect.description')}
      </Text>
      <Button color="danger" icon="unplug" onClick={handleDisconnectClick} variant="outlined">
        {t('settings.organization.card_payments.configuration.disconnect.button')}
      </Button>
    </Flex>
  )
}
